import {
  PANEL_MAP_FIT_MAX_ZOOM,
  PANEL_MAP_FIT_MIN_ZOOM,
  PANEL_MAP_FIT_PADDING
} from '@/features/panel-planning/utils/panelMapMotion';

export const HIERARCHY_FIT_PADDING = PANEL_MAP_FIT_PADDING;
/** 모듈리스트 Array 이동은 즉시 (확대 애니메이션 없음) */
export const HIERARCHY_FIT_DURATION_MS = 0;
export const HIERARCHY_FIT_MAX_ZOOM = PANEL_MAP_FIT_MAX_ZOOM;
export const HIERARCHY_FIT_MIN_ZOOM = PANEL_MAP_FIT_MIN_ZOOM;

export function extentFromFeatures(features) {
  let extent = null;
  for (const feature of features || []) {
    const next = feature?.getGeometry?.()?.getExtent?.();
    if (!next || next.length !== 4) {
      continue;
    }
    if (!extent) {
      extent = next.slice();
      continue;
    }
    extent[0] = Math.min(extent[0], next[0]);
    extent[1] = Math.min(extent[1], next[1]);
    extent[2] = Math.max(extent[2], next[2]);
    extent[3] = Math.max(extent[3], next[3]);
  }
  return extent;
}

export function centerFromExtent(extent) {
  if (!extent || extent.length !== 4) {
    return null;
  }
  return [(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2];
}

/** Array가 넓거나 좌표가 튀어도 패널 작업 줌(20)보다 축소하지 않음 */
export function resolveFitZoom(zoomForExtent, options = {}) {
  const maxZoom = options.maxZoom ?? HIERARCHY_FIT_MAX_ZOOM;
  const minZoom = options.minZoom ?? HIERARCHY_FIT_MIN_ZOOM;
  if (zoomForExtent == null || Number.isNaN(zoomForExtent)) {
    return maxZoom;
  }
  return Math.min(maxZoom, Math.max(minZoom, zoomForExtent));
}

function zoomForExtentOnMap(map, view, extent, padding) {
  const size = map.getSize?.();
  if (!size || typeof view.getResolutionForExtent !== 'function') {
    return null;
  }
  const paddedSize = [
    Math.max(1, size[0] - padding[1] - padding[3]),
    Math.max(1, size[1] - padding[0] - padding[2])
  ];
  const resolution = view.getResolutionForExtent(extent, paddedSize);
  if (typeof view.getZoomForResolution !== 'function') {
    return null;
  }
  return view.getZoomForResolution(resolution);
}

/**
 * @returns {boolean} 이동 호출 여부
 */
export function fitMapToFeatures(map, features, options = {}) {
  const view = map?.getView?.();
  const extent = extentFromFeatures(features);
  const center = centerFromExtent(extent);
  if (!view || !extent || !center) {
    return false;
  }

  const padding = options.padding || HIERARCHY_FIT_PADDING;
  const duration = options.duration ?? HIERARCHY_FIT_DURATION_MS;
  const maxZoom = options.maxZoom ?? HIERARCHY_FIT_MAX_ZOOM;
  const minZoom = options.minZoom ?? HIERARCHY_FIT_MIN_ZOOM;
  const zoomForExtent = zoomForExtentOnMap(map, view, extent, padding);
  const targetZoom = resolveFitZoom(zoomForExtent, { minZoom, maxZoom });

  view.cancelAnimations?.();
  if (duration > 0 && typeof view.animate === 'function') {
    view.animate({ center, zoom: targetZoom, duration });
    return true;
  }
  view.setCenter?.(center);
  view.setZoom?.(targetZoom);
  return true;
}
